import {
  ActiveFilters,
  Filters,
  Grid,
  Main,
  Search,
  ShowMore,
  StyledGallery,
  Types,
} from '@/scenes/Gallery/styles';
import qs from 'qs';
import isEmpty from 'lodash.isempty';
import startCase from 'lodash.startcase';
import GalleryTypes from '@/scenes/Gallery/Types';
import GalleryItems from '@/scenes/Gallery/Items';
import { inject, observer } from 'mobx-react';
import { IGalleryStore } from '@/stores/Gallery';
import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Button from '@/components/UI/Button';
import GallerySearch from '@/scenes/Gallery/Search';
import GalleryFilters from '@/scenes/Gallery/Filters';
import GalleryActiveFilters from '@/scenes/Gallery/ActiveFilters';
import GalleryNotFound from '@/scenes/Gallery/404';
import GalleryLoading from '@/scenes/Gallery/Loading';

interface GallerySceneProps {
  galleryStore: IGalleryStore;
}

const GalleryScene: FC<any> = ({ galleryStore }: GallerySceneProps) => {
  const router = useRouter();
  const [loaded, setLoaded] = useState<boolean>(false);

  const {
    queryString,
    activeType,
    types,
    selectType,
    bears,
    loadBears,
    currentTotal,
    search,
    setSearch,
    toggleFilter,
    activeFilters,
    loading,
    loadingMore,
  } = galleryStore;

  useEffect(() => {
    if (isEmpty(router.query)) return;

    const { type, s, filters } = router.query;

    if (type) {
      // @ts-ignore
      selectType(types.find((t) => t.label === type).toJSON(), true);
    }

    if (filters) {
      const rawFilters = JSON.parse(filters.toString());
      const filtersToSet = [];

      Object.keys(rawFilters).forEach((f) => {
        if (f === '$or') {
          rawFilters[f].forEach((item) => {
            filtersToSet.push({
              group: {
                type: startCase(Object.entries(item)[0][0]),
              },
              option: {
                // @ts-ignore
                value: Object.entries(item)[0][1].$eq,
              },
            });
          });
        } else {
          filtersToSet.push({
            group: {
              type: startCase(f),
            },
            option: {
              value: rawFilters[f].$eq,
            },
          });
        }
      });

      filtersToSet.forEach(({ group, option }) =>
        toggleFilter(group, option, true, true),
      );
    }

    if (s) {
      // @ts-ignore
      setSearch(s, true);
    }

    loadBears(true);
  }, [router.query.type, router.query.s, router.query.filters]);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (!loaded) return;

    const query: any = {};

    if (activeType.label !== 'All') {
      query.type = activeType.label;
    }

    if (search) {
      query.s = search;
    }

    if (queryString.filters) {
      query.filters = JSON.stringify(queryString.filters);
    }

    // TODO: think how we can make browser back button work in this case
    // maybe we need to call this whole effect body in another place/trigger
    return window.history.pushState(
      { scroll: false },
      '',
      Object.keys(query).length
        ? `/gallery?${qs.stringify(query)}`
        : '/gallery',
    );
  }, [queryString]);

  const onShowMore = () => {
    loadBears(false, true);
  };

  return (
    <StyledGallery>
      <div className="container">
        <Grid>
          <Types>
            <GalleryTypes />
          </Types>
          <Search>
            <GallerySearch />
          </Search>
          <Filters>
            <GalleryFilters />
          </Filters>
          <ActiveFilters empty={!activeFilters.length}>
            <GalleryActiveFilters />
          </ActiveFilters>
          <Main>
            {!loading && <GalleryItems />}
            {loading && <GalleryLoading />}
            {!bears.length && !loading && <GalleryNotFound />}
          </Main>
          {bears.length < currentTotal && !loading && (
            <ShowMore>
              {!loadingMore && (
                <Button type="secondary" colored onClick={onShowMore}>
                  Show more
                </Button>
              )}
              {loadingMore && <GalleryLoading small />}
            </ShowMore>
          )}
        </Grid>
      </div>
    </StyledGallery>
  );
};

export default inject('galleryStore')(observer(GalleryScene));
